module.exports = __webpack_public_path__ + "img/p2.d7a7ace7.png";